import React, { useState } from 'react';
import { IconGoogle } from '../../components/Icons';
import { signInWithGoogle, checkUserExists } from '../../core/firebase/auth_service';

export default function AuthLanding({ onCreateAccount, onLogin, onSuccess, onGoogleNewUser }) {
  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const [error, setError] = useState('');

  const handleGoogle = async () => {
    setLoadingGoogle(true);
    setError('');
    try {
      const user = await signInWithGoogle();
      const exists = await checkUserExists(user.uid);
      if (exists) {
        onSuccess();
      } else {
        onGoogleNewUser(user);
      }
    } catch (e) {
      if (e.code !== 'auth/popup-closed-by-user') {
        setError('Google sign-in failed. Please try again.');
      }
    } finally {
      setLoadingGoogle(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.logoCard}>
        <img src="/og-image.png" alt="Nexsap" style={styles.logoImg} />
      </div>

      <h1 style={styles.appName}>Nexsap</h1>
      <p style={styles.tagline}>Discover and share amazing products</p>

      <div style={styles.actions}>
        <button
          style={styles.btnGoogle}
          onClick={handleGoogle}
          disabled={loadingGoogle}
        >
          <IconGoogle size={20} />
          <span>{loadingGoogle ? 'Signing in...' : 'Continue with Google'}</span>
        </button>

        <div style={styles.orRow}>
          <div style={styles.line} />
          <span style={styles.orText}>or</span>
          <div style={styles.line} />
        </div>

        <button style={styles.btnSecondary} onClick={onCreateAccount}>
          Create account with email
        </button>

        <button style={styles.btnLink} onClick={onLogin}>
          I already have an account
        </button>

        {error && <p style={styles.error}>{error}</p>}
      </div>

      <p style={styles.terms}>
        By continuing, you accept our{' '}
        <span style={styles.link}>Terms of Service</span>
        {' '}and our{' '}
        <span style={styles.link}>Privacy Policy</span>
      </p>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f5f7ff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 24px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  logoCard: {
    width: 120,
    height: 120,
    background: '#fff',
    borderRadius: 28,
    boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
    overflow: 'hidden',
    padding: 0,
  },
  logoImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 28,
  },
  appName: {
    fontSize: 28,
    fontWeight: 800,
    color: '#1a1a2e',
    margin: '0 0 6px',
  },
  tagline: {
    fontSize: 14,
    color: '#888',
    margin: '0 0 40px',
  },
  actions: {
    width: '100%',
    maxWidth: 480,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  btnGoogle: {
    background: '#fff',
    color: '#333',
    border: '1.5px solid #dde0f0',
    borderRadius: 14,
    height: 54,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  },
  orRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    margin: '4px 0',
  },
  line: { flex: 1, height: 1, background: '#dde0f0' },
  orText: { color: '#999', fontSize: 14, fontWeight: 500 },
  btnSecondary: {
    background: '#3d5ef5',
    color: '#fff',
    border: 'none',
    borderRadius: 14,
    height: 54,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    width: '100%',
  },
  btnLink: {
    background: 'none',
    border: 'none',
    color: '#3d5ef5',
    fontSize: 15,
    fontWeight: 500,
    cursor: 'pointer',
    textAlign: 'center',
    padding: '4px 0',
  },
  terms: {
    color: '#aaa',
    fontSize: 13,
    textAlign: 'center',
    marginTop: 32,
    maxWidth: 340,
    lineHeight: 1.6,
  },
  link: { color: '#3d5ef5', cursor: 'pointer', fontWeight: 500 },
  error: { color: '#e74c3c', fontSize: 13, textAlign: 'center' },
};
